import { Stack, Typography, useTheme, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FoodsToggleButton, SearchBox } from "@foodpilot/foods";
import { useResponsiveBreakpoints } from "src/utils/useResponsiveBreakpoints";
import { isAppInPDFMode } from "src/utils/rendering";
import { ActiveOrganizationContextHeader } from "src/components/ActiveOrganizationContextHeader";

type GridPageHeaderProps = {
    label?: string;
    title: string;
    filter?: string;
    setFilter?: (newFilter: string) => void;
};
export const GridPageHeader = (props: GridPageHeaderProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { label, filter = null, setFilter, title } = props;

    const isPdfMode = isAppInPDFMode();
    // Responsive breakpoints centralisés
    const { isMobile } = useResponsiveBreakpoints();

    if (isPdfMode) {
        return null;
    }

    const buttons = [{ id: 1, label }];

    return (
        <Stack
            direction={isMobile ? "column" : "row"}
            useFlexGap
            alignItems={isMobile ? "stretch" : "center"}
            justifyContent={isMobile ? "flex-start" : "space-between"}
            gap={isMobile ? theme.spacing(2) : 0}
        >
            <Stack direction="row" useFlexGap alignItems="center" gap={theme.spacing(2)}>
                <ActiveOrganizationContextHeader title={<Typography variant="h1">{title}</Typography>} />
                {label && <FoodsToggleButton buttons={buttons} initialSelected={buttons[0]} />}
            </Stack>
            {setFilter && (
                <Box sx={{ width: isMobile ? "100%" : "auto" }}>
                    <SearchBox
                        variant="standalone"
                        value={filter}
                        placeholder={t("rechercher_un_element")}
                        onChange={setFilter}
                    />
                </Box>
            )}
        </Stack>
    );
};
